export { default as GDMDivider } from './GDMDivider';

export type { GDMDividerComponent, GDMDividerProps } from './GDMDivider.type';
